import { render, staticRenderFns } from "./NewPlaceOrder.vue?vue&type=template&id=5405bb5d&scoped=true&"
import script from "./NewPlaceOrder.vue?vue&type=script&lang=js&"
export * from "./NewPlaceOrder.vue?vue&type=script&lang=js&"
import style0 from "./NewPlaceOrder.vue?vue&type=style&index=0&id=5405bb5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5405bb5d",
  null
  
)

export default component.exports